<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xocKz7/tc-custom/9781523098033.jpg?1725276352278" alt="This image is the cover for the book Big Four"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Big Four
      </h1>
      <p class="bookDescription body article font2">
        <b>"Messrs. Gow and Kells have made an invaluable contribution, writing in an amused tone that nevertheless acknowledges the firms' immense power and the seriousness of their neglect of traditional responsibilities. 'The Big Four' will appeal to all those interested in the future of the profession--and of capitalism itself." —Jane Gleeson-White, Wall Street Journal</b><br/><br/> With staffs that are collectively larger than the Russian army and combined revenues of over $130 billion a year, the Big Four accounting firms—Deloitte, PricewaterhouseCoopers, Ernst &amp; Young, and KPMG—are a keystone of global commerce. But leading scholar Ian Gow and award-winning author Stuart Kells warn that a house of cards may be about to fall.<br/><br/> Stretching back to the Medicis in Renaissance Florence, this book is a fascinating story of wealth, power, and luck. The founders of the Big Four lived surprisingly colorful lives. Samuel Price, for example, married his own niece. Between the world wars, Nicholas Waterhouse collected postage stamps while also hosting decadent parties in his fashionable London home.<br/><br/> All four firms have endured major calamities in recent decades. There have been hundreds of court cases and legal prosecutions for failed audits, tax scandals, and breaches of independence. The firms have come so close to “extinction level events” that regulators have required them to prepare “living wills.” And today, the Big Four face an uncertain future—thanks to their push into China, their vulnerability to digital disruption and competition, and the hazards of providing traditional services in a new era of transparency.<br/><br/> This account of the past, present, and likely future of the Big Four is essential reading for anyone perplexed or fascinated by professional services, working or considering working in the industry, or simply curious about the fate of the global economy.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian D. Gow, Stuart Kells
      </h2>
      
      <p class="authorDescription body article">Ian D. Gow is director of the Melbourne Centre for Corporate Governance and Regulation at the University of Melbourne. He has served on the faculties of Harvard Business School and the Kellogg School of Management at Northwestern University. He has also held positions at Morgan Stanley, General Motors, Stern Stewart & Co., and Andersen Consulting.</P><br/><br/><P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0bf85bd8